export default __webpack_public_path__ + "static/media/ante-trust-s.4f08ceed.svg";